import {FascicoloFull} from "../../../../common/models/fascicolo/fascicolo-full";
import {TipoTipologica} from "../../../../common/models/tipologiche/tipo-tipologica";
import {QuestionBase} from "../../../../core/components/dynamic-form/models/question-base";

export class FascicoloRicorsoAmministrativo extends FascicoloFull {
  //integrato: boolean;
  //dataIntegrazione: number;
  esitoDelibera: string;
  numeroDelibera: string;
  dataDelibera: number;
  esitoDefinitivo: boolean;
  numeroGiuntaEsecutiva: string;
  dataGiuntaEsecutiva: number;
  oggettoRicorso: TipoTipologica;
  organoCompetente: TipoTipologica;
  dataProvvedimento: number;
  numeroProvvedimento: string;

  constructor() {
    super();
    this.dataInizioFascicolo = +new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([
      {
        key: 'oggettoRicorso',
        label: 'Oggetto ricorso',
        required: true,
        controlType: 'dropdown',
        placeholder: 'Inserire Oggetto ricorso',
        size: 'sm-3',
        value: this.oggettoRicorso
      },
      {
        key: 'numeroProvvedimento',
        label: 'N° provvedimento impugnato',
        required: false,
        controlType: 'textbox',
        placeholder: 'Inserire N° provvedimento impugnato',
        size: 'sm-3',
        type: 'number',
        value: this.numeroProvvedimento
      },
      {
        key: 'dataProvvedimento',
        label: 'Data provvedimento impugnato',
        required: false,
        controlType: 'date',
        placeholder: 'Inserire Data provvedimento impugnato',
        size: 'sm-3',
        value: this.dataProvvedimento
      },
      {
        key: 'organoCompetente',
        label: 'Organo',
        required: false,
        controlType: 'dropdown',
        placeholder: 'Inserire Organo',
        size: 'sm-3',
        value: this.organoCompetente
      }
    ] as QuestionBase[]);
  }
}
